<template>
  <div>
    <div
      v-if="showAlert"
      role="alert"
      :class="'alert ' + alertClass"
      data-aos="fade-down"
    >
      <i class="fas fa-times-circle" />
      <p class="el-message__content">{{ alertMessage }}</p>
    </div>
    <!-- ========== Main Content - Home ========== -->
    <!-- Pricing Section -->
    <div class="container fade pt-5 show active">
      <!-- Plan Description -->
      <!-- March 11 update: Unconditionally hide this for now -->
      <!-- <div v-if="planData[0] && planData[0].plan_description" class="mb-9 pt-5">
        <h3>{{ $t('M08c-03a') }}</h3>
        <p>{{ planData[0].plan_description }}</p>
      </div> -->
      <!-- End Description -->
      <!-- Table -->
      <div v-if="plans.length > 0" class="d-lg-none">
        <input v-for="option in planOptions" :id="option.value" :key="option.value" v-model="selectedPlanNameForTable" type="radio" name="categories" :value="option.value">
        <ol class="filters-btn">
          <li v-for="option in planOptions" :key="option.value" @click="changeOption(option.value)">
            <label :class="(selectedPlanNameForTable.toLowerCase() === option.value.toLowerCase() ? 'theme-selected-plan' : 'btn-soft-secondary')" class="btn btn-xs btn-pill py-2 px-3 m-1 theme-plan-filter" :for="option.value">{{ $t(option.label) }}</label>
          </li>
        </ol>
      </div>
      <div v-if="plans.length > 0" class="table-responsive pb-4">
        <!-- Desktop View -->
        <div class="desktop-table">
          <div :class="{ 'table-container': plans.length === 1 }">
            <div :class="{ 'scrollable': plans.length === 1 }">
              <table class="table" :class="plans.length > 1 ? 'table-full-width' : 'table-one-column'">
                <tbody>
                  <tr class="first-row">
                    <td v-for="plan in plans" :key="plan.id" class="plan-info-container">
                      <div class="plan-name">{{ $t(plan.show_name) }}</div>
                    </td>
                  </tr>
                  <tr class="button">
                    <td v-for="plan in plans" :key="plan.id" class="plan-info-container">
                      <div>
                        <div v-if="!plan.is_price_shown">
                          <div class="plan-price-container no-description">
                            <div class="plan-price">{{ $t('M08c-06a-02') }}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="plan-price-container">
                            <div class="plan-currency">{{ plan.plan_currency }}</div>
                            <div class="plan-price">{{ plan.plan_price }}</div>
                          </div>
                          <div class="price-description">{{ $t(plan.payment_period) }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="button">
                    <td v-for="plan in plans" :key="plan.id" class="plan-info-container">
                      <div class="plan-button">
                        <span v-if="getPlanButtonType(plan) === 'subscribeForFree'">
                          <button
                            data-gtm-att="ga-M08c-10-02"
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : handlePurchasePlan(plan)"
                          >
                            {{ $t('M08c-10-02') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(plan) === 'subscribe'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded || plan.subscription_status === 'error' || apiInfo[0].billing_info[0].billing_account_status !== 'ENABLED'"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : handlePurchasePlan(plan)"
                          >
                            {{ $t('M08c-10-01b') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(plan) === 'subscribeToUpdate'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="plan.plan_price > 0 ? !subscriptionLoaded || plan.subscription_status === 'error' || apiInfo[0].billing_info[0].billing_account_status !== 'ENABLED' : !subscriptionLoaded"
                            @click="handlePurchasePlan(plan)"
                          >
                            {{ $t('M08c-10-03a') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(plan) === 'viewMyPlan'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="redirectToSubscribedPlan(plan.api_id)"
                          >
                            {{ $t('M08c-10-03') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(plan) === 'changeMyPlan'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="changePlanTarget = plan"
                          >
                            {{ $t('M08c-10-05') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(plan) === 'viewSubscriptionRecord'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="redirectToPurchaseRecord()"
                          >
                            {{ $t('M08c-10-04') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(plan) === 'talkToUs'">
                          <button
                            data-gtm-att="ga-M08c-10-06"
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded || plan.subscription_status === 'error'"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : contactProvider(plan.plan_name)"
                          >
                            {{ $t('M08c-10-06') }}
                          </button>
                        </span>
                        <span v-else>
                          <button
                            data-gtm-att="ga-M08c-10-01"
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded || plan.subscription_status === 'error'"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : contactUs(plan.plan_name)"
                          >
                            {{ $t('M08c-10-01') }}
                          </button>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr class="last-row">
                    <td v-for="plan in plans" :key="plan.id">
                      <hr class="hr">
                      <div>
                        <div v-for="detail in detailList" :key="detail.field">
                          <div v-if="detail.is_shown_if_null || plan[detail.field]" class="detail-item">
                            <div class="title">{{ $t(detail.name) }}</div>
                            <div v-if="plan[detail.field]" class="point">
                              <div v-if="detail.is_icon_shown"><i class="fas fa-check icon theme-icon" /></div>
                              <div>
                                <div>{{ $t(plan[detail.field]) }}</div>
                                <div v-if="plan[`${detail.field}_description`]" class="point-description">
                                  <span v-if="plan[`${detail.field}_description`] === 'M08c-07b-01'">{{ $t(plan[`${detail.field}_description`]) }} {{ plan.plan_currency }} {{ plan.overuse_charge }}</span>
                                  <span v-else>{{ $t(plan[`${detail.field}_description`]) }}</span>
                                </div>
                              </div>
                            </div>
                            <div v-else>-</div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Desktop View -->
        <!-- Mobile View -->
        <div class="mobile-table">
          <div>
            <div>
              <table class="table">
                <tbody>
                  <tr class="first-row">
                    <td class="plan-info-container">
                      <div class="plan-name">{{ $t(selectedPlanForTable.show_name) }}</div>
                    </td>
                  </tr>
                  <tr class="button">
                    <td class="plan-info-container">
                      <div>
                        <div v-if="!selectedPlanForTable.is_price_shown">
                          <div class="plan-price-container no-description">
                            <div class="plan-price">{{ $t('M08c-06a-02') }}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="plan-price-container">
                            <div class="plan-currency">{{ selectedPlanForTable.plan_currency }}</div>
                            <div class="plan-price">{{ selectedPlanForTable.plan_price }}</div>
                          </div>
                          <div class="price-description">{{ $t(selectedPlanForTable.payment_period) }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="button">
                    <td class="plan-info-container">
                      <div class="plan-button">
                        <span v-if="getPlanButtonType(selectedPlanForTable) === 'subscribeForFree'">
                          <button
                            data-gtm-att="ga-M08c-10-02"
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : handlePurchasePlan(selectedPlanForTable)"
                          >
                            {{ $t('M08c-10-02') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(selectedPlanForTable) === 'subscribe'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded || selectedPlanForTable.subscription_status === 'error' || apiInfo[0].billing_info[0].billing_account_status !== 'ENABLED'"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : handlePurchasePlan(selectedPlanForTable)"
                          >
                            {{ $t('M08c-10-01b') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(selectedPlanForTable) === 'subscribeToUpdate'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!selectedPlanForTable || selectedPlanForTable.plan_price > 0 ? !subscriptionLoaded || selectedPlanForTable.subscription_status === 'error' || apiInfo[0].billing_info[0].billing_account_status !== 'ENABLED' : !subscriptionLoaded"
                            @click="handlePurchasePlan(selectedPlanForTable)"
                          >
                            {{ $t('M08c-10-03a') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(selectedPlanForTable) === 'viewMyPlan'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="redirectToSubscribedPlan(selectedPlanForTable.api_id)"
                          >
                            {{ $t('M08c-10-03') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(selectedPlanForTable) === 'changeMyPlan'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="changePlanTarget = selectedPlanForTable"
                          >
                            {{ $t('M08c-10-05') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(selectedPlanForTable) === 'viewSubscriptionRecord'">
                          <button
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded"
                            @click="redirectToPurchaseRecord()"
                          >
                            {{ $t('M08c-10-04') }}
                          </button>
                        </span>
                        <span v-else-if="getPlanButtonType(selectedPlanForTable) === 'talkToUs'">
                          <button
                            data-gtm-att="ga-M08c-10-06"
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded || selectedPlanForTable.subscription_status === 'error'"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : contactProvider(selectedPlanForTable.plan_name)"
                          >
                            {{ $t('M08c-10-06') }}
                          </button>
                        </span>
                        <span v-else>
                          <button
                            data-gtm-att="ga-M08c-10-01"
                            class="theme-button btn btn-primary"
                            :disabled="!subscriptionLoaded || selectedPlanForTable.subscription_status === 'error'"
                            @click="userProfile.id === '' ? redirectToLoginToContinue() : contactUs(selectedPlanForTable.plan_name)"
                          >
                            {{ $t('M08c-10-01') }}
                          </button>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr class="last-row">
                    <td>
                      <hr class="hr">
                      <div>
                        <div v-for="detail in detailList" :key="detail.field">
                          <div v-if="detail.is_shown_if_null || selectedPlanForTable[detail.field]" class="detail-item">
                            <div class="title">{{ $t(detail.name) }}</div>
                            <div v-if="selectedPlanForTable[detail.field]" class="point">
                              <div v-if="detail.is_icon_shown"><i class="fas fa-check icon theme-icon" /></div>
                              <div>
                                <div>{{ $t(selectedPlanForTable[detail.field]) }}</div>
                                <div v-if="selectedPlanForTable[`${detail.field}_description`]" class="point-description">
                                  <span v-if="selectedPlanForTable[`${detail.field}_description`] === 'M08c-07b-01'">{{ $t(selectedPlanForTable[`${detail.field}_description`]) }} {{ selectedPlanForTable.plan_currency }} {{ selectedPlanForTable.overuse_charge }}</span>
                                  <span v-else>{{ $t(selectedPlanForTable[`${detail.field}_description`]) }}</span>
                                </div>
                              </div>
                            </div>
                            <div v-else>-</div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Mobile View -->
      </div>
      <!-- End Table -->
    </div>
    <!-- End Pricing Section -->
    <!-- Contact Us Banner -->
    <div v-if="isCustomPlan" class="container mx-lg-auto mt-5">
      <div id="contact-us-banner" class="card overflow-hidden p-5">
        <div class="row justify-content-md-start align-items-md-center text-center text-md-left z-index-2">
          <div class="col-md-8 col-lg-9 mb-3 mb-md-0 pl-lg-5">
            <h4 class="mb-0">{{ $t('M08c-12a') }}</h4>
          </div>

          <div class="col-md-4 col-lg-3 text-md-right">
            <button data-gtm-att="ga-M08c-10-06" class="theme-button btn btn-primary" @click="userProfile.id === '' ? redirectToLoginToContinue() : contactProvider('Custom')">
              {{ $t('M08c-12b') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Contact Us Banner -->
    <div class="space-1" />
    <!-- ========== End Main Content - Home ========== -->

    <b-modal id="purchase-plan-dialog" ref="purchase-plan-dialog" centered hide-footer>
      <template slot="modal-header-close">
        <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" aria-label="Close">
          <img :src="require(`@/assets/svg/icons/icon-68.svg`)">
        </button>
      </template>
      <div v-if="selectedPlan" class="modal-body">
        <div v-if="!subscriptionLoaded" class="d-flex justify-content-center loading-layer">
          <div class="spinner-border theme-spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <h5 id="planTitle" class="modal-title">{{ $t('M08c-10-02a') }}</h5>
        <h3 class="heading">{{ $t('M08c-10-02b', { name: $t(selectedPlan.show_name) }) }}</h3>
        <div class="table-responsive">
          <div class="text-align-left">
            <div>
              <div>
                <table class="table">
                  <tbody>
                    <tr class="first-row">
                      <td class="plan-info-container">
                        <div class="plan-name">{{ $t(selectedPlan.show_name) }}</div>
                      </td>
                    </tr>
                    <tr class="button">
                      <td class="plan-info-container">
                        <div>
                          <div v-if="!selectedPlan.is_price_shown">
                            <div class="plan-price-container no-description">
                              <div class="plan-price">{{ $t('M08c-06a-02') }}</div>
                            </div>
                          </div>
                          <div v-else>
                            <div class="plan-price-container">
                              <div class="plan-currency">{{ selectedPlan.plan_currency }}</div>
                              <div class="plan-price">{{ selectedPlan.plan_price }}</div>
                            </div>
                            <div class="price-description">{{ $t(selectedPlan.payment_period) }}</div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr class="last-row">
                      <td>
                        <hr class="hr">
                        <div>
                          <div v-for="detail in detailList" :key="detail.field">
                            <div v-if="detail.is_shown_if_null || selectedPlan[detail.field]" class="detail-item">
                              <div class="title">{{ $t(detail.name) }}</div>
                              <div v-if="selectedPlan[detail.field]" class="point">
                                <div v-if="detail.is_icon_shown"><i class="fas fa-check icon theme-icon" /></div>
                                <div>
                                  <div>{{ $t(selectedPlan[detail.field]) }}</div>
                                  <div v-if="selectedPlan[`${detail.field}_description`]" class="point-description">
                                    <span v-if="selectedPlan[`${detail.field}_description`] === 'M08c-07b-01'">{{ $t(selectedPlan[`${detail.field}_description`]) }} {{ selectedPlan.plan_currency }} {{ selectedPlan.overuse_charge }}</span>
                                    <span v-else>{{ $t(selectedPlan[`${detail.field}_description`]) }}</span>
                                  </div>
                                </div>
                              </div>
                              <div v-else>-</div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="tooltip-span remainer">
            <i class="fas fa-info-circle ml-1 remainer-icon" />
            <div class="remainer-text" v-html="$t('M08c-10-02g', { terms_of_use_url: getEditableInfo('footer_content', 'terms_of_use_url', false), privacy_policy_url: getEditableInfo('footer_content', 'privacy_policy_url', false) })" />
          </div>
        </div>
        <button id="ga-M08c-10-02h" type="button" class="theme-button btn btn-sm btn-primary text-nowrap" :disabled="!subscriptionLoaded" @click="subscribePlan(selectedPlan)">{{ $t('M08c-10-02h') }}</button>
      </div>
    </b-modal>

    <b-modal id="contact-platform" ref="contact-platform" centered hide-footer @hide="hideContactPlatform">
      <template slot="modal-header-close">
        <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" aria-label="Close">
          <img :src="require(`@/assets/svg/icons/icon-68.svg`)">
        </button>
      </template>
      <div id="hubspotPlanForm" />
    </b-modal>

    <!-- Modal for Alert Message on payment status change -->
    <b-modal
      v-model="showPaymentStatusMessage"
      centered
      modal-class="close-dialog"
      :title="paymentStatusMessage"
      @cancel="paymentStatusMessage = null"
      @ok="paymentStatusMessage = null"
    >
      <template #modal-header>
        <div class="modal-header" />
      </template>

      <div class="dialog-message">
        {{ paymentStatusMessage }}
      </div>

      <template #modal-footer="{ ok }">
        <template v-if="confirmPaymentStatusRefreshPage">
          <b-button size="sm" class="button" variant="primary" @click="$router.go()">
            {{ $t('CC15-03') }}
          </b-button>
        </template>
        <template v-else-if="alreadySubscribedPlan !== ''">
          <b-button size="sm" class="button" variant="primary" @click="alreadySubscribedPlan = ''; redirectToSubscribedPlan(alreadySubscribedPlan);">
            {{ $t('M08c-10-03') }}
          </b-button>
        </template>
        <template v-else>
          <b-button size="sm" class="button" variant="primary" @click="ok">
            {{ $t('CC15-03') }}
          </b-button>
        </template>
      </template>
    </b-modal>

    <!-- Modal for CC23 Change New Plan -->
    <b-modal
      v-model="changePlanTarget"
      centered
      modal-class="close-dialog"
      :title="$t('CC23-01-01')"
      @cancel="changePlanTarget = null"
      @ok="subscribePlan(changePlanTarget)"
    >
      <template #modal-header="{ close }">
        <div class="modal-header">
          <h5 class="dialog-header">{{ $t('CC23-01-01') }}</h5>
          <button type="button" aria-label="Close" class="close" @click="close">×</button>
        </div>
      </template>

      <div class="dialog-message">
        {{ $t('CC23-01-02') }}
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" class="button" variant="outline-secondary" @click="cancel">
          {{ $t('CC23-01-03b') }}
        </b-button>
        <b-button size="sm" class="button" variant="primary" @click="ok">
          {{ $t('CC23-01-03a') }}
        </b-button>
      </template>
    </b-modal>

    <!-- Hubspot Form - Contact Modal -->
    <!-- <div id="contactForm" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="contactFormTitle" aria-hidden="true">
      <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="contactFormTitle" class="modal-title" />
            <button type="button" class="btn btn-xs btn-icon btn-soft-secondary" data-dismiss="modal" aria-label="Close">
              <svg aria-hidden="true" width="10" height="10" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z" />
              </svg>
            </button>
          </div> -->
    <!-- Body -->
    <!-- <div class="modal-body">
            <div class="w-md-90 mx-auto mb-6 form-submit">
              <form ref="contactForm" />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Hubspot Form - Contact Modal -->
  </div>
</template>

<script>
const $ = require('jquery')
import apiInfoMixin from '@/mixins/api-info'
import providerInfoMixin from '@/mixins/provider-info'
import getEditableInfo from '@/utils/get-editable-info'

import {
  createApiSubscriptionPlan,
  getAPIInfo,
  getDeveloperCurrentSubscribedPlan,
  createStripeCheckoutSession,
  createStripeNewPriceSubscription
} from '@/api/api-info'
import getRuntimeConfig from '@/utils/get-runtime-config'

export default {
  name: 'ApiInfoPricing',
  directives: {
    tooltip: {
      bind: function bsTooltipCreate(el, binding) {
        $(el).tooltip({
          title: binding.value,
          placement: binding.arg,
          trigger: 'hover',
          html: true
        })
      }
    }
  },
  mixins: [apiInfoMixin, providerInfoMixin],
  props: {
    planData: {
      type: Array,
      default: () => []
    },
    themeColor: {
      type: String,
      default: '#57ABF0'
    }
  },
  data() {
    return {
      api_id: '',
      plans: [],
      subscription_status: {
        Starter: 'none',
        Lite: 'none',
        Pro: 'none',
        Advanced: 'none',
        Premium: 'none'
      },
      planOptions: [],
      selectedPlanNameForTable: '',
      selectedPlan: '',
      isCustomPlan: false,
      subscribedPlan: [],
      DEVELOPER_PORTAL_URL: '',
      showAlert: false,
      alertMessage: '',
      alertClass: '',
      detailList: [
        {
          name: 'M08c-03a',
          field: 'plan_description',
          is_icon_shown: false,
          is_shown_if_null: false
        },
        {
          name: 'M08c-04a-03',
          field: 'plan_charge_type',
          is_icon_shown: true,
          is_shown_if_null: true
        },
        {
          name: 'M08c-04a-04',
          field: 'plan_quota',
          is_icon_shown: true,
          is_shown_if_null: true
        }
        // {
        //   name: 'M08c-04a-05',
        //   field: 'rate_limit',
        //   is_icon_shown: true,
        //   is_shown_if_null: true
        // }
      ],
      subscriptionLoaded: false,
      subscribed_plan_detail: null,
      changePlanTarget: null,
      paymentStatusMessage: null,
      confirmPaymentStatusRefreshPage: false,
      alreadySubscribedPlan: ''
    }
  },
  computed: {
    userProfile() {
      return this.$store.getters.userProfile
    },
    selectedPlanForTable() {
      return this.plans.find(plan => plan.plan_name === this.selectedPlanNameForTable) || {}
    },
    hasPendingOrActivePlan() {
      return Object.keys(this.subscribed_plan_detail).length > 0
    },
    showPaymentStatusMessage() {
      return this.paymentStatusMessage !== null
    }
  },
  watch: {
    planData: {
      deep: true,
      handler() {
        this.initialise()
      }
    }
  },
  beforeDestroy() {
    window.document.styleSheets[0].deleteRule(window.document.styleSheets[0].cssRules.length - 1)
  },
  async created() {
    const runtimeConfig = await getRuntimeConfig()
    this.DEVELOPER_PORTAL_URL = runtimeConfig.DEVELOPER_PORTAL_URL
    await this.initialise()
  },
  mounted() {
    var sheet = window.document.styleSheets[0]
    sheet.insertRule(
      `#contact-us-banner {
        background: url(${require(`@/assets/svg/components/half-circle-gray.svg`)}) no-repeat;
      }`,
      sheet.cssRules.length
    )
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      await this.getSubscriptionPlan()
      await this.getSubscribedPlanDetails()
      this.subscriptionLoaded = true
      this.$store.dispatch('app/setLoading', false)

      //  Handle status message after Stripe payment.
      if (this.$route.query.status) {
        switch (this.$route.query.status) {
          case 'success':
            this.paymentStatusMessage = this.$t('M08c-10-02h-02a')
            break

          default:
            this.paymentStatusMessage = this.$t('M08c-10-02h-02b')
            break
        }

        this.$router.replace({
          query: {
            ...this.$route.query,
            status: undefined
          }
        })
      }
    },
    async getSubscriptionPlan() {
      this.plans = []
      console.log('planData', this.planData)
      //  Push plans data to plans array
      for (var plan of this.planData) {
        if (plan.pricing_model === 'subscription') {
          switch (plan.billing_period) {
            case 'monthly':
              plan['plan_charge_type'] = 'M08c-09b-01'
              plan['payment_period'] = 'M08c-06b-01'
              break
            case 'annually':
              plan['plan_charge_type'] = 'M08c-09b-02'
              plan['payment_period'] = 'M08c-06b-02'
              break
          }
        } else {
          plan['plan_charge_type'] = '-'
        }
        switch (plan.plan_name) {
          case 'Free':
          case 'Free Plan':
          case 'Trial':
          case 'Starter':
            plan.plan_name = 'Starter'
            plan.show_name = 'M08c-05-01'
            this.plans.splice(0, 0, plan)
            break
          case 'Basic':
          case 'Lite':
            plan.plan_name = 'Lite'
            plan.show_name = 'M08c-05-05'
            this.plans.splice(1, 0, plan)
            break
          case 'Pro':
            plan.plan_name = 'Pro'
            plan.show_name = 'M08c-05-02'
            this.plans.splice(2, 0, plan)
            break
          case 'Advanced':
            plan.plan_name = 'Advanced'
            plan.show_name = 'M08c-05-06'
            this.plans.splice(3, 0, plan)
            break
          case 'Premium':
            plan.plan_name = 'Premium'
            plan.show_name = 'M08c-05-03'
            this.plans.splice(4, 0, plan)
            break
          default: this.plans.push(plan)
            break
        }
        if (plan.overuse_charge !== null) {
          plan.plan_quota_description = `M08c-07b-01`
        } else {
          plan.plan_quota_description = 'M08c-07b-02'
        }
        if (plan.plan_price !== null) {
          plan.is_price_shown = true
        } else {
          if (plan.plan_charge_type === null) {
            plan.plan_currency = 'USD'
            plan.plan_price = 0
            plan.payment_period = null
            plan.is_price_shown = true
          } else {
            plan.plan_quota_description = null
            plan.is_price_shown = false
          }
        }
      }
      if (this.plans.length > 0) {
        var sortOrder = ['Starter', 'Lite', 'Pro', 'Advanced', 'Premium']
        this.plans.sort((a, b) => { return sortOrder.indexOf(a.plan_name) - sortOrder.indexOf(b.plan_name) })
      }
      this.isCustomPlan = this.apiInfo[0].is_custom_plan_supported
      await this.initialiseButtonAction()
      // this.isCustomPlan = true // demo custom plan styling
      this.planOptions = this.plans.map(plan => {
        return { value: plan.plan_name, label: plan.show_name }
      })
      this.selectedPlanNameForTable = this.planOptions[0] ? this.planOptions[0].value : ''
    },
    async getSubscribedPlanDetails() {
      await getDeveloperCurrentSubscribedPlan(this.apiInfo[0].id)
        .then(res => {
          //  res.data is either null or a JSON. Anyway, we should store
          //  this to this.subscribed_plan_detail .
          this.subscribed_plan_detail = res.data.length > 0 ? res.data[0] : null
        }).catch(err => {
          console.log(err)
        })

      //  TODO: Uncomment and edit this for mocked data.
      //  Below line is used to determine which plan is active.
      // const activePlan = 'Starter'
      // const planId = this.planData.filter(plan => plan.name === activePlan)[0]?.id
      // this.subscribed_plan_detail = planId ? {
      //   developer_profile_id: this.userProfile.id,
      //   api_id: this.apiInfo[0].id,
      //   api_subscription_plan_id: this.planData ? planId : null,
      //   api_subscription_plan_version: 1238,
      //   subscription_status: 'pending_to_active'
      // } : null
    },
    contactProvider() {
      window.location.href = `mailto:${this.providerInfo[0].company_business_email}`
    },
    contactUs(plan_name) {
      this.selectedPlan = plan_name
      const to = this.getEditableInfo('subscription_contact_us', 'action', false)
      if (to.type === 'router') {
        this.$router.push({
          name: to.name,
          params: to.params
        })
      } else if (to.type === 'link') {
        window.open(to.link, '_blank')
      } else if (to.type === 'external-link') {
        const url = this.getEditableInfo(to.link_type, to.link_id)
        window.open(url, '_blank')
      } else if (to.type === 'email') {
        window.location.href = `mailto:${to.email_address}`
      } else if (to.type === 'hubspot') {
        const formId = to.form_id[plan_name.toLowerCase()] ? to.form_id[plan_name.toLowerCase()] : ''
        this.showFormDialog(to.portal_id, formId)
      }
    },
    showFormDialog(portalId, formId) {
      const script = document.createElement('script')
      script.src = 'https://js.hsforms.net/forms/v2.js'
      document.body.appendChild(script)
      script.addEventListener('load', () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: 'na1',
            portalId: portalId,
            formId: formId,
            errorClass: 'hubspotFormError',
            target: `#hubspotPlanForm`
          })
        }
      })
      this.$nextTick(() => {
        this.$refs['contact-platform'].show()
      })
    },
    hideContactPlatform() {
      this.selectedPlan = ''
    },
    redirectToSubscribedPlan(apiId) {
      window.location.href = `${this.DEVELOPER_PORTAL_URL}/#/manage-subscription/${apiId}`
    },
    redirectToPurchaseRecord() {
      window.location.href = `${this.DEVELOPER_PORTAL_URL}/#/payment-record/index`
    },
    redirectToLoginToContinue() {
      const redirectURL = `${window.location.pathname}`
      window.open(`${window.location.origin}/${this.$i18n.locale}/login-to-continue?redirect=${encodeURIComponent(redirectURL)}`, '_blank')
    },
    handlePurchasePlan(plan) {
      this.selectedPlan = plan
      this.$refs['purchase-plan-dialog'].show()
    },
    async subscribePlan(plan) {
      this.subscriptionLoaded = false
      this.$store.dispatch('app/setLoading', true)
      const current_price = this.subscribed_plan_detail?.plan_price || null
      const current_over_usage_charge = this.subscribed_plan_detail?.over_usage_charge || null
      //  Determine which flow according to plan.price and existing record -
      //  Case 1 - new price > 0, no existing subscribe record that needed payment:
      //    => Call stripe checkout URL and proceed there.
      //  Case 2 - has existing subscribe record:
      //    => Call stripe new price subscription record endpoint.
      //  Case 3 - new price = 0:
      //    => Call /rpc endpoint.
      if (
        (plan.price > 0 && (current_price === null || current_price === 0) && (current_over_usage_charge === null || current_over_usage_charge === 0)) ||
        ((plan.overuse_charge && plan.overuse_charge > 0) && (current_price === null || current_price === 0) && (current_over_usage_charge === null || current_over_usage_charge === 0))
      ) {
        //  Case 1
        await createStripeCheckoutSession(
          this.userProfile.id,
          plan.id,
          plan.plan_version
        )
          .then(async res => {
            window.location.href = res.data.url
          }).catch(err => {
            //  Link generation failure.
            console.log(err)
            this.setAlert(this.$t('err-general-05-03'), 'error')
          }).finally(() => {
            this.subscriptionLoaded = true
            this.$store.dispatch('app/setLoading', false)
          })
      } else if (current_price > 0 || current_over_usage_charge > 0) {
        //  Case 2
        await createStripeNewPriceSubscription(
          this.userProfile.id,
          plan.id,
          plan.plan_version
        )
          .then(async res => {
            if (res.data.url) {
              window.location.href = res.data.url
            } else {
              this.$refs['purchase-plan-dialog'].hide()
              this.confirmPaymentStatusRefreshPage = true
              this.paymentStatusMessage = this.$t('M08c-10-02h-02d')
            }
          }).catch(err => {
            console.log(err)
            if (err.status === 400 && err.body.message === 'developer subscribed plan exist') {
              this.$refs['purchase-plan-dialog'].hide()
              this.paymentStatusMessage = this.$t('M08c-10-02h-02e')
              this.alreadySubscribedPlan = plan.id
            } else {
              this.setAlert(this.$t('err-general-05-03'), 'error')
            }
          }).finally(() => {
            this.subscriptionLoaded = true
            this.$store.dispatch('app/setLoading', false)
          })
      } else {
        //  Case 3
        await createApiSubscriptionPlan(plan.id, plan.plan_version).then(async res => {
          await this.getSubscribedPlanDetails()
          await this.initialiseButtonAction()
          this.$refs['purchase-plan-dialog'].hide()
          this.confirmPaymentStatusRefreshPage = true
          //  TODO: Possible handling for other messages?
          this.paymentStatusMessage = this.$t('M08c-10-02h-02a')
        }).catch(err => {
          console.log(err)
          if (err.status === 422 && err.body.message.toLowerCase() === 'Specified API subscription plan is still active'.toLowerCase()) {
            this.$refs['purchase-plan-dialog'].hide()
            this.paymentStatusMessage = this.$t('M08c-10-02h-02e')
            this.alreadySubscribedPlan = plan.id
          } else {
            this.setAlert(this.$t('err-general-05-03'), 'error')
          }
        }).finally(() => {
          this.subscriptionLoaded = true
          this.$store.dispatch('app/setLoading', false)
        })
      }
    },
    async initialiseButtonAction() {
      const plan_id = this.$route.name === 'api-info-branded-unlisted-pricing' ? this.$route.params.plan_id : ''
      await getAPIInfo(this.userProfile.id, this.apiInfo[0].api_short_id, plan_id)
        .then(async res => {
          var subscriptionPlans = res['data'][0].subscription_plans
          subscriptionPlans.map(plan => {
            switch (plan.name) {
              case 'Free':
              case 'Free Plan':
              case 'Trial':
              case 'Starter':
                plan.plan_name = 'Starter'
                break
              case 'Basic':
              case 'Lite':
                plan.plan_name = 'Lite'
                break
              case 'Pro':
                plan.plan_name = 'Pro'
                break
              case 'Advanced':
                plan.plan_name = 'Advanced'
                break
              case 'Premium':
                plan.plan_name = 'Premium'
                break
            }
            this.$set(this.subscription_status, plan.plan_name, plan.subscription_status)
          })
        })
        .catch(error => {
          console.log('getAPIInfo error', error)
        })
    },
    //  Get what button should a given plan show.
    getPlanButtonType(plan) {
      const subscriptionStatus = (plan.id && this.subscribed_plan_detail && this.subscribed_plan_detail?.api_subscription_plan_id === plan.id)
        ? this.subscribed_plan_detail.subscription_status
        : 'none'
      const isOnLatestVersion = this.subscribed_plan_detail?.api_subscription_plan_version >= plan.plan_version
      //  Need to keep this for 'Change My Plan' case.
      const placeholder_false = false

      //  Determining logic:
      //  - https://kb2.benovelty.net/pages/viewpage.action?spaceKey=OAH&title=Billing+Integration+with+Stripe+Backend+Spec
      //  - https://kb2.benovelty.net/pages/viewpage.action?pageId=66073063
      if (
        (plan.price > 0 || plan.overuse_charge > 0) &&
        (
          this.subscribed_plan_detail === null ||
          (
            subscriptionStatus === 'none' && this.subscribed_plan_detail?.plan_price === 0 &&
            (this.subscribed_plan_detail?.over_usage_charge === null || this.subscribed_plan_detail?.over_usage_charge === 0)
          )
        )
      ) {
        //  == Subscribe ==
        //  Show condition:
        //  - Plan Price > 0 OR Overage Charge > 0,
        //  - No current subscribed plan OR currently subscribed a free plan
        return 'subscribe'
      } else if (
        plan.price === 0 &&
        (plan.overuse_charge === null || plan.overuse_charge === 0) &&
        (
          this.subscribed_plan_detail === null ||
          (
            subscriptionStatus === 'none' && this.subscribed_plan_detail?.plan_price === 0 &&
            (this.subscribed_plan_detail?.over_usage_charge === null || this.subscribed_plan_detail?.over_usage_charge === 0)
          )
        )
      ) {
        //  == Subscribe For Free ==
        //  Show condition:
        //  - Plan Price = 0,
        //  - Overage Charge = null OR 0,
        //  - No current subscribed plan OR currently subscribed a free plan
        return 'subscribeForFree'
      } else if (
        (
          subscriptionStatus === 'active' ||
          subscriptionStatus.startsWith('pending_to_')
        ) &&
        !isOnLatestVersion
      ) {
        //  == Plan Updated - Confirm Renewal? ==
        //  Show condition:
        //  - Current subscribed plan is active or pending.
        //  - Current subscribed plan NOT on latest version.
        return 'subscribeToUpdate'
      } else if (
        (
          subscriptionStatus === 'active' ||
          subscriptionStatus === 'pending_to_active'
        ) &&
        isOnLatestVersion
      ) {
        //  == View My Plan ==
        //  Show condition:
        //  - Current subscribed plan is active or pending_to_active.
        //  - Current subscribed plan on latest version.
        return 'viewMyPlan'
      } else if (
        subscriptionStatus === 'pending_to_payment' &&
        isOnLatestVersion
      ) {
        //  == View Subscription Record ==
        //  Show condition:
        //  - Current subscribed plan is pending_to_payment.
        //  - Current subscribed plan on latest version.
        return 'viewSubscriptionRecord'
      } else if (
        placeholder_false
      ) {
        //  TODO: Currently hide this option. Ignore this for now.
        //  == Change My Plan ==
        //  Show condition:
        //  - TODO: Ignore this for now.
        return 'changeMyPlan'
      } else {
        //  == Talk To Us ==
        //  Show condition:
        //  - Plan with Custom Price.
        return 'talkToUs'
      }
      // } else {
      //   //  == Contact Platform ==
      //   //  Show condition:
      //   //  - User has other active / pending plans.
      //   //  - Default to be the exclusive case from other plans.
      //   return 'contactPlatform'
      // }
    },
    //  Handle showing alert.
    setAlert(alertMessage, alertClass) {
      if (!this.showAlert) {
        this.showAlert = true
        this.alertMessage = alertMessage
        this.alertClass = alertClass
        setTimeout(() => { this.showAlert = false }, 2000)
      }
    },
    changeOption(plan_name) {
      this.selectedPlanNameForTable = plan_name
    },
    getEditableInfo(type, id, withLangCode = true) {
      return getEditableInfo(type, id, withLangCode ? this.$i18n.locale : '')
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 992px) {
  // mobile
  .desktop-table {
    display: none;
  }
}
@media (min-width: 992px) {
  // desktop
  .mobile-table {
    display: none;
  }
}
.plan-description-label {
  font-size: 20px;
}
.disabled {
  cursor: not-allowed;
}
.price-tag {
  color: #a0a0a0 !important;
  font-size: 0.8rem;
  padding: 0px !important;
  font-weight: normal;
}
.modal-header {
  margin-bottom: -30px;
  margin-top: -15px;
  padding-top: 0.5rem;
  text-align: center;
  width: 100%;
  .modal-title {
    margin-top: 5px;
    text-align: center;
    width: 100%;
  }
}
.text-align-left {
  text-align: left;
}
.table-container {
  display: flex;
  justify-content: center;
  .scrollable {
    overflow-x: auto;
  }
}
th, td {
  vertical-align: middle !important;
}
.modal-dialog {
  max-width: 80% !important;
  width: 80% !important;
}
.modal-body {
  padding: 0px !important;
  text-align: center;
  tr {
    th:first-child {
      text-align: left !important;
    }
  }
  .tooltip-span {
    font-size: 0.8rem;
  }
}
.price-highlighted {
  margin-top: 5px;
  color: #57ABF0;
  font-weight: 600;
}
.sticky-first-col-table {
  thead tr th, tbody tr:nth-of-type(even) {
    background-color: #fff !important;
  }
	tr th:first-child, tr td:first-child {
    position: sticky;
    min-width: 100px;
    left: 0px;
    background-color: inherit;
  }
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fafafa;
}
.modal-title, .heading {
  margin-bottom: 16px;
}
.remainer {
  margin: 16px 0px;
  display: flex;
  flex-direction: row;
  .remainer-icon {
    line-height: inherit;
    margin-right: 5px;
  }
  .remainer-text {
    text-align: left;
  }
}

.alert {
  position: fixed;
  left: 50%;
  top: 20px;
  margin-left: -270px;
  padding: 15px;
  padding-left: 20px;
  z-index: 2000;

  width: 540px;
  border-radius: 4px;

  display: flex;
  align-items: center;

  i {
    margin-right: 10px;
  }

  p {
    color: inherit;
    font-size: 14px;
    line-height: 1;
    margin-bottom: 0px;
    padding: 0px;
  }
}

.alert.success {
  background-color: #f0f9eb;
  border: #e1f3d8 1px solid;
  color: #67c23a;
}

.alert.error {
  background-color: #ffeded;
  border: #e6ebf5 1px solid;
  color: #ff4949;
}

.plan-table-title-container {
  text-align: center;
  .title {
    font-size: 20px;
    margin-bottom: 16px;
  }
  .description {
    margin-bottom: 32px;
  }
}
th {
  text-align: center;
}
td {
  font-size: 14px;
  line-height: 19px;
  padding-left: 16px !important;
  padding-right: 16px !important;
}
td > hr {
  margin-top: 0px;
  margin-bottom: 24px;
  border-top: 0.0625rem solid #e7eaf3;
}
.table-one-column {
  width: fit-content;
  th, td {
    min-width: 500px;
  }
}
.table-full-width {
  width: 100%;
  table-layout: fixed;
}
.table th, .table td {
  border: 1px solid #e7eaf3;
}
.table td {
  background-color: #FFFFFF;
  vertical-align: top !important;
}
.table > tbody > tr.first-row > td{
  padding-top: 24px;
  padding-bottom: 0px;
  border-bottom: none;
}
.table > tbody > tr.button > td, .table > tbody > tr.price-detail > td{
  padding: 0px;
}
.table > tbody > tr:not(.first-row, .last-row) > td{
  border-bottom: none;
  border-top: none;
}
.table > tbody > tr.last-row > td{
  border-top: none;
  padding-bottom: 24px;
}

.detail-item {
  margin-bottom: 24px;
  .icon {
    color: #57ABF0;
    width: 12px;
    height: 9px;
    margin: 0px 8px;
  }
  .title {
    font-weight: 600;
    color: #1C344C;
    margin-bottom: 8px;
  }
  .point {
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    .point-description {
      font-size: 12px;
      color: #999999;
    }
  }
}

.plan-info-container {
  text-align: center;
  .plan-name {
    font-size: 20px;
    line-height: 1;
    color: #1C344C;
    margin-bottom: 16px;
  }
  .plan-description {
    margin-bottom: 16px;
  }
  .plan-price-container {
    margin-bottom: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .plan-currency {
      color: #57ABF0;
    }
    .plan-price {
      font-size: 30px;
      line-height: 1;
      color: #1C344C;
    }
  }
  .no-description {
    margin-bottom: 24px;
  }
  .price-description {
    margin-bottom: 24px;
    color: #999999;
  }
  .plan-button {
    margin-bottom: 24px;
    button {
      width: 100%;
      white-space: break-spaces;
    }
  }
}
.hr {
  margin-top: 0px;
  margin-bottom: 24px;
  border-top: 0.0625rem solid #e7eaf3;
}
.selected-plan, .plan-filter:hover {
  background: #1c344c !important;
  color: #fff !important;
}
button:disabled {
  cursor: not-allowed;
}
.loading-layer {
  z-index: 2000;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(256, 256, 256, 0.5);
  .spinner-border {
    margin: auto;
  }
}
.button  {
  margin: 0.25rem 0.5rem;
}
.dialog-header {
  font-size: 1.2rem;
  margin-left: 50px;
  margin-top: 15px;
  width: 100%;
}
.dialog-message {
  margin: -10px 0;
  text-align: center;
}
</style>
